import { useState, useEffect } from "react";

export function useScreenType() {
  const getType = () => {
    const width = window.innerWidth;

    if (width < 640) return "mobile"; // < 640px
    if (width < 1024) return "tablet"; // 640px - 1023px
    return "desktop"; // >= 1024px
  };

  const [screenType, setScreenType] = useState(getType());

  useEffect(() => {
    const onResize = () => setScreenType(getType());
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return screenType;
}
